import { loadStripe } from "@stripe/stripe-js";

const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!key) {
  console.error(
    "Missing VITE_STRIPE_PUBLISHABLE_KEY environment variable. " +
      "Stripe Elements will not work without it."
  );
}

// `loadStripe` is called once and returns a Promise<Stripe>.
// It loads Stripe.js from Stripe's CDN on first call, then
// caches the result.
export const stripePromise = key ? loadStripe(key) : null;
